import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  ChatBubbleLeftRightIcon,
  CalendarIcon,
  UserGroupIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid,
  CalendarIcon as CalendarIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  SparklesIcon as SparklesIconSolid,
} from '@heroicons/react/24/solid';

const MobileBottomNav = () => {
  const mobileNavigation = [
    { name: 'Home', href: '/dashboard', icon: HomeIcon, solidIcon: HomeIconSolid },
    { name: 'Chat', href: '/chat', icon: ChatBubbleLeftRightIcon, solidIcon: ChatBubbleLeftRightIconSolid },
    { name: 'Calendar', href: '/events', icon: CalendarIcon, solidIcon: CalendarIconSolid },
    { name: 'Team', href: '/roster', icon: UserGroupIcon, solidIcon: UserGroupIconSolid },
    { name: 'AI Analysis', href: '/video-analysis', icon: SparklesIcon, solidIcon: SparklesIconSolid },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_10px_rgba(15,23,42,0.08)] safe-bottom">
      <div className="flex items-center justify-around px-1.5 py-0.5">
        {mobileNavigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center py-1.5 px-2.5 rounded-lg transition-colors min-w-0 flex-1 ${
                isActive
                  ? 'text-blue-600 bg-blue-50'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <item.solidIcon className="h-5 w-5 mb-0.5" />
                ) : (
                  <item.icon className="h-5 w-5 mb-0.5" />
                )}
                <span className="text-[10px] font-medium leading-tight truncate">{item.name}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
